<template>
    <main-content>
        <kt-panel>

            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#setting" @click="gotoTab(1)">
                                {{ $t('label.basic_settings') }}
                            </a>
                        </li>
                        <li class="nav-item" v-if="$can('read', 'notification')">
                            <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#messageSetting" @click="gotoTab(2)">
                                {{ $t('label.message_settings') }}
                            </a>
                        </li>
                    </ul>
                    <div class="button-group dropleft" v-if="$can('change-setting', 'notification')">
                        <button class="btn btn-success dropdown-toggle"
                                data-toggle="dropdown">
                            {{ $t('label.requests') }}
                        </button>
                        <div class="dropdown-menu">
                            <button @click="sendRequest('setting')" class="dropdown-item btn-dark my-1">
                                {{ $t('label.upload_settlement_file')}}
                            </button>
                            <button @click="sendRequest('messageSetting')"  class="dropdown-item btn-info my-1">
                                {{ $t('label.download_file_uploaded')}}
                            </button>

                        </div>
                    </div>


                </kt-panel-header-toolbar>
            </kt-panel-header>
            <kt-panel-body>
                <div class="tab-content">
                    <div :class="['tab-pane', currentTab === 1 ? 'active' : '']">
                        <notification-form
                            :form_data="form_data"
                            :submit="submit"
                        >
                        </notification-form>
                    </div>
                    <div v-if="$can('read', 'notification')" :class="['tab-pane', currentTab === 2 ? 'active' : '']">
                        <notification-message/>

                    </div>
                </div>
            </kt-panel-body>

        </kt-panel>

    </main-content>
</template>

<script>
import MainContent from "@/components/main-content.vue";
import NotificationForm from "@/views/notificationTelegram/component/form.vue";
import {mapActions, mapGetters} from "vuex";
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {telegramNotificationService} from "@/common/api.service";
import NotificationMessage from "@/views/notificationTelegram/component/message.vue";

export default {
    name: "Get",
    components: {NotificationMessage, NotificationForm, MainContent},
    computed: {
        ...mapGetters('notification', [
            'form_data', 'status'
        ]),
        ...mapActions('notification', ['fetchTelegramSetting'])
    },
    mounted() {
        this.fetchTelegramSetting()
    },
    data() {
        return {
            currentTab: 1
        }
    },
    methods: {
        submit(e) {
            let form = $('#settings_form')
            let btn = $('#submit_btn')

            KTApp.progress(btn)

            let params = this.form_data

            telegramNotificationService.update(params).then(response => {
                this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            })
                .finally(() => {
                        KTApp.unprogress(btn)
                    }
                )
        },
        sendRequest() {

        },
        gotoTab(number) {
            this.currentTab = number
        },

    }
}
</script>

<style scoped>

</style>